var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg12IconFeatherIconsSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#2E3A59",
    strokeWidth: 1.333
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31.000000, -131.000000) translate(24.000000, 118.055709) translate(8.000000, 14.500000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 2.182
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.382 10.182c-.198.449-.103.973.24 1.323l.043.044c.274.273.427.643.427 1.03 0 .385-.153.755-.427 1.028-.272.273-.643.427-1.029.427-.386 0-.756-.154-1.029-.427l-.043-.043c-.351-.343-.875-.438-1.324-.24-.44.188-.725.62-.727 1.098v.123c0 .804-.651 1.455-1.455 1.455-.803 0-1.454-.651-1.454-1.455v-.065c-.012-.493-.323-.928-.786-1.098-.449-.198-.973-.103-1.323.24l-.044.043c-.273.274-.643.427-1.03.427-.385 0-.755-.153-1.028-.427-.273-.272-.427-.643-.427-1.029 0-.386.154-.756.427-1.029l.043-.043c.343-.351.438-.875.24-1.324-.188-.44-.62-.725-1.098-.727h-.123C.65 9.513 0 8.862 0 8.058c0-.803.651-1.454 1.455-1.454h.065c.493-.012.928-.323 1.098-.786.198-.449.103-.973-.24-1.323l-.043-.044c-.274-.273-.427-.643-.427-1.03 0-.385.153-.755.427-1.028.272-.273.643-.427 1.029-.427.386 0 .756.154 1.029.427l.043.043c.351.343.875.438 1.324.24h.058c.44-.188.726-.62.727-1.098v-.123C6.545.65 7.197 0 8 0s1.455.651 1.455 1.455v.065c.001.478.287.91.727 1.098.449.198.973.103 1.323-.24l.044-.043c.273-.274.643-.427 1.03-.427.385 0 .755.153 1.028.427.273.272.427.643.427 1.029 0 .386-.154.756-.427 1.029l-.043.043c-.343.351-.438.875-.24 1.324v.058c.188.44.62.726 1.098.727h.123C15.35 6.545 16 7.197 16 8s-.651 1.455-1.455 1.455h-.065c-.478.001-.91.287-1.098.727z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12IconFeatherIconsSettings);
export default __webpack_public_path__ + "static/media/1-2-icon-feather-icons-settings.ae0c01df.svg";
export { ForwardRef as ReactComponent };